export function dashboardHomeSurface({ mode, chat, canvas, canChat, connectGate }) {
    if (mode !== "dashboard") return null;
    if (connectGate) return "connect";
    if (chat === "1" && canChat) return "chat";
    if (chat === null && canvas === null) {
        if (canChat) return "chat";
    }
    return "canvas";
}
